import { ArchiveManagerProvider } from '../archive-manager';
import { Platform } from '@ionic/angular';

export class UnzipItemData{
filePath: string;
fileName: string;
platform : Platform;

constructor(
    public archiveMgr : ArchiveManagerProvider
    ){
      this.platform = this.archiveMgr.injector.get(Platform);

    // if(this.platform.is("cordova")){
    //     this.initSuggestions();
    // }
}
initSuggestions(){
    let outPut ="../assets/archive/out/suggestions.sql";
    let outName ="suggestions.sql";
    let path = "www/assets/archive/suggestions/";
    this.fileName = "sggstns.by";
    // this.filePath = this.archiveMgr.file.applicationDirectory+path;
  }

  import(path,fileName){
    let outName =fileName.replace(".zip",".sql");
    let outNameFolder ="itemsData/";
    let self = this;
    // this.archiveMgr.file.checkFile(path,fileName).then(()=>{

    //   self.archiveMgr.zip.unzip(
    //     path+fileName,
    //     self.archiveMgr.file.cacheDirectory+outNameFolder).then(
    //       (result)=>{
    //         if(result === 0){
              
    //           this.logger.debug('SUCCESS');
    //           self.archiveMgr.file.checkFile(self.archiveMgr.file.cacheDirectory+outNameFolder+"/",outName).then(fileRes=>{
    //                 self.archiveMgr.file.readAsText(self.archiveMgr.file.cacheDirectory+outNameFolder,outName).then(sqlString=>{
    //                     self.archiveMgr.databaseMgr.importSQL(sqlString);
    //                 })
    //                 .catch(err=>{
    //                     this.logger.debug("err on reading file",self.archiveMgr.file.cacheDirectory,outName);
    //                 })
    //             }).catch(fileResErr=>{
    //               this.logger.debug(fileResErr);
    //             })
    //           } 
    //           if(result === -1){
                
    //             this.logger.debug('FAILED');
    //           } 
    //         }
    //       )
    //     }).catch(e=>{
    //       this.logger.debug("file not exists",e);
    //     })
    }
  }